import { Component, ComponentRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort} from '@angular/material/sort';
import moment from 'moment';
import { SelectConsultationComponent } from 'src/app/pages/user/patient/dossier-patient/documents-patient/historique-imageries/select-consultation/select-consultation.component';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { AUTEUR_AUTRE, Consultation } from 'src/app/utils/interfaces/new/consultation.interface';
import { DocumentMetadata } from 'src/app/utils/interfaces/new/DocumentMetadata';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { PatientAccessProfil } from 'src/app/utils/interfaces/new/PatientAccessProfil';
import { AskNextDocument, DisplayDocumentComponent } from '../display-document/display-document.component';
import { ConsultationType, ImportDocumentsComponent } from '../import-documents/import-documents.component';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { ApercuCrbioComponent } from '../modal/apercu-crbio/apercu-crbio.component';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { DmpService } from 'src/app/services/dmp/dmp.service';
import { DmpVisibilityEnum } from 'src/app/utils/enums/dmp-visibility.enum';
import { Validators } from '@angular/forms';
import { LoadingModalFragment } from '../modal/loading/loading-modal.fragment';
import { MatTableDataSource } from '@angular/material/table';
import { ConsultationInfos, ModalCreateConsultationComponent } from '../import-documents/modal-create-consultation/modal-create-consultation.component';
import { LoginService } from 'src/app/services/login/login.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { QuickSendMSSFragment } from '../modal/quick-send-mss/quick-send-mss.fragment';
import { DocumentAccessControlService } from 'src/app/services/document-access-control/document-access-control.service';

export interface DocumentTableDisplay {
  createdAt: string;
  upDatedAt: string;
  title: string;
  formatFileSize?: string;
  consultationTitre: string;
  consultationDat: string;
  consultationType: string;
  cdaType: string;
  cdaDate: string;
  author: string;
  id: string;
  meta: DocumentMetadata;
  envoyeDMP?: string;
  visibilityDMP?: DmpVisibilityEnum | string;
}

@Component({
  selector: 'app-list-add-documents',
  templateUrl: './list-add-documents.component.html',
  styleUrls: ['./list-add-documents.component.scss'],
})
export class ListAddDocumentsComponent
  implements OnInit, OnChanges
{
  @Input() public patientId: string;
  @Input() public consultations: Array<Consultation>;
  @Input() public consultationTypes: Array<ConsultationType>;
  @Input() public dmpTypes: Array<DocumentType>;
  @Input() public patientaccessProfils: Array<PatientAccessProfil>;
  @Input() public uniqueConsultation: Consultation;
  @Input() public documentsTable: Paginated<DocumentTableDisplay>;
  @Input() public documentWithoutConsultation: Array<DocumentMetadata>;
  @Input() public showDisplay = true;
  @Input() public comparisonMode: boolean = false;
  @Input() public selectedImagesIds: string[] = [];
  @Input() public isSelectionLimitReached: boolean = false;
  @Output() public importOver = new EventEmitter();
  @Output() public onChangePage = new EventEmitter();
  @Output() public onChangePerPage = new EventEmitter<number>();
  @Output() public onSort = new EventEmitter();
  @Output() public onImageSelectionToggle = new EventEmitter<DocumentMetadata>();
  @ViewChild('importDocumentsComponent')
  public importDocumentsComponent: ImportDocumentsComponent;

  public dataSource = new MatTableDataSource<DocumentTableDisplay>();
  private _paginator: MatPaginator;
  private _sort: MatSort;
  public canSendToPatient = true;
  public displayedColumns: string[] = [];
  public canSendToPro = true;
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this._paginator = value;
  }
  get paginator(): MatPaginator {
    return this._paginator;
  }

  @ViewChild(MatSort)
  set sort(value: MatSort) {
    this._sort = value;
    if (this.dataSource && value) {
      this.dataSource.sort = value;
    }
  }
  get sort(): MatSort {
    return this._sort;
  }

  showAutresActions: boolean = false;
  private _loadingRef: any;

  toggleShowAutresActions() {
    this.showAutresActions = !this.showAutresActions;
  }

  public documentsTableColumn = [];

  constructor(
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _documentSrv: DocumentService,
    private _consultationSrv: ConsultationService,
    private _displayDocumentSrv: DisplayDocumentService,
    private _strUtilsSrv: StringUtilsService,
    private _snakeBarSrv: SnackbarService,
    private _dmp: DmpService,
    private _cdRef: ChangeDetectorRef,
    private _login: LoginService,
    private _patientSrv: PatientService,
    private _accessControl: DocumentAccessControlService
  ) {}

  async ngOnInit(): Promise<void> {
    const fichePatient = await this._patientSrv.findOnePatientFiche(
      this.patientId
    );
    this.canSendToPatient =
      fichePatient.mssPatientConsentement &&
      fichePatient.identiteStatutId ===
        '95a6081f-5260-44b8-9661-e4795e1cfcaf' &&
      !!fichePatient.ins &&
      !!fichePatient.insKey;

    if (this.uniqueConsultation) {
      this.documentsTableColumn = [
        { title: 'Titre document', data: 'title' },
        { title: 'Taille document', data: 'formatFileSize' },
        { title: 'Titre consultation', data: 'consultationTitre' },
        { title: 'Date consultation', data: 'consultationDat' },
        { title: '', data: null },
        { title: '', data: null },
      ];
      this.displayedColumns = [
        'title',
        'formatFileSize',
        'consultationTitre',
        'consultationDat',
        'actions',
        'info',
      ];
    } else {
      this.documentsTableColumn = [
        { title: 'Titre document', data: 'title' },
        { title: 'Taille document', data: 'formatFileSize' },
        { title: 'Titre consultation', data: 'consultationTitre' },
        { title: "Date d'intégration", data: 'createdAt' },
        { title: 'Date consultation', data: 'consultationDat' },
        { title: 'DMP', data: 'envoyeDMP' },
        { title: 'Visibilité DMP', data: 'visibilityDMP' },
        { title: 'Autres actions', data: null },
        { title: '', data: null },
      ];
      this.displayedColumns = [
        'title',
        'formatFileSize',
        'consultationTitre',
        'createdAt',
        'consultationDat',
        'envoyeDMP',
        'visibilityDMP',
        'actions',
        'info',
      ];
    }

    this.refreshDataSourceFromInput();
  }

  private setDataSource(data: DocumentTableDisplay[]): void {
    // On met à jour les données sans recréer le DataSource,
    // sinon le lien avec le MatPaginator serait perdu à chaque refresh
    this.dataSource.data = data || [];
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documentsTable'] && !changes['documentsTable'].firstChange) {
      this.refreshDataSourceFromInput();
    }
    if (changes['comparisonMode']) {
      this.updateDisplayedColumns();
    }
  }

  private refreshDataSourceFromInput(): void {
    if (this.documentsTable?.objects) {
      this.setDataSource(this.documentsTable.objects);
    } else {
      this.setDataSource([]);
    }
  }

  private updateDisplayedColumns(): void {
    const baseColumns = this.uniqueConsultation
      ? ['title', 'formatFileSize', 'consultationTitre', 'consultationDat', 'actions', 'info']
      : ['title', 'formatFileSize', 'consultationTitre', 'createdAt', 'consultationDat', 'envoyeDMP', 'visibilityDMP', 'actions', 'info'];
    
    if (this.comparisonMode) {
      this.displayedColumns = ['select', ...baseColumns];
    } else {
      this.displayedColumns = baseColumns;
    }
  }

  //bloquer
  public async removeDocument(document: DocumentTableDisplay): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      const modal = this._modalSrv.openModalConfirmation(
        this._viewContainerRef,
        'Confirmation',
        'Voulez-vous supprimer ce document ?'
      );
      modal.instance.closeEmitter.subscribe(async (res: boolean) => {
        if (res) {
          await this._documentSrv.deleteDocument(document.id);

          const updatedData = this.dataSource.data.filter(
            (d) => d.id !== document.id
          );
          this.setDataSource(updatedData);
        }
      });
    } catch (e) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        "Une erreur s'est produite lors de la suppression de ce document."
      );
    } finally {
      this._modalSrv.close(loading);
    }
  }

  //bloquer
  public async renameDocument(document: DocumentTableDisplay): Promise<void> {
    const modal = this._modalSrv.openModalAddEdit(
      'Renommer document',
      this._viewContainerRef,
      {
        inputs: [
        {
          id: 'new_name',
          label: 'Titre du document',
          placeholder: '',
          type: 'text',
          variable: 'new_name',
          required: true,
          validators: [Validators.required],
          style: {width: '300px'}
        }].filter(i => !!i)
      },
      true,
      { new_name: document?.title },
    );
    const sub = this._modalSrv.closeEmitter.subscribe(async (v: any) => {
      const value = v.object;
      if (value && value.new_name) {
        try {
          await this._documentSrv.renameDocument(document.id, value.new_name);
          // Mise à jour locale du tableau sans refetch
          this.updateDocumentTitleInTable(document.id, value.new_name);
          this._snakeBarSrv.openSnackBar('Document renommé avec succès');
        } catch (error) {
          this._modalSrv.openAlert(this._viewContainerRef, 'Erreur',
            'Une erreur s\'est produite lors du renommage de ce document.');
        }
      }

      if (v.loadingModal) {
        (v.loadingModal as ComponentRef<LoadingModalFragment>).destroy();
      }

      sub.unsubscribe();
      modal.destroy();
    });
  }

  /**
   * Met à jour le titre d'un document dans le tableau local sans refetch
   * @param documentId - L'ID du document à mettre à jour
   * @param newTitle - Le nouveau titre du document
   */
  private updateDocumentTitleInTable(documentId: string, newTitle: string): void {
    // Trouver l'index du document dans le tableau
    const documentIndex = this.documentsTable.objects.findIndex(doc => doc.id === documentId);
    
    if (documentIndex !== -1) {
      this.documentsTable.objects[documentIndex].title = newTitle;
      this.documentsTable.objects[documentIndex].meta.titre = newTitle;
      
      // Forcer la détection des changements pour que le tableau se mette à jour visuellement
      this.documentsTable = { ...this.documentsTable };
    }
  }

  //bloquer
  public async assocConsultation(
    document: DocumentTableDisplay
  ): Promise<void> {
    if (document.meta.consultation) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Déjà associé',
        "Ce document est déjà associé à une consultation.\nIl est impossible de modifier la consultation d'un document."
      );
      return;
    }

    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      // On récupère la liste des consultations avant des les passer à la pop-up
      const consultations = await this._consultationSrv.find(this.patientId);

      // On ouvre la pop-up et on lui passe les consultations
      const modal = this._modalSrv.openModal<SelectConsultationComponent>(
        this._viewContainerRef,
        SelectConsultationComponent
      ) as ComponentRef<SelectConsultationComponent>;
      // Passer la liste des consultations du patient à la pop-up
      modal.instance.consultations = consultations.objects;
      const sub = modal.instance.closeEmitter.subscribe(
        (consultationId?: string) => {
          if (consultationId) {
            // On associe le document à la consultation sélectionnée
            const newDocument =
              this._documentSrv.convertDocumentToCreationDocument(
                document.meta
              );
            newDocument.consultationId = consultationId;
            this._documentSrv.updateDocument(document.id, newDocument);
            const consultation = consultations.objects.find(
              (c) => c.id === consultationId
            );
            document.consultationTitre = consultation.titre;
            document.consultationDat = consultation.date.toString();
            document.consultationType = consultation.typeConsultation;
          }
          modal.destroy();
          sub.unsubscribe();
        }
      );
    } catch (e) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        "Une erreur s'est produite lors de l'association de ce document à un consultation."
      );
    } finally {
      this._modalSrv.close(loading);
    }
  }

  private async createConsultationModal(): Promise<
    ConsultationInfos | undefined
  > {
    return new Promise<ConsultationInfos | undefined>(
      async (resolve, reject) => {
        try {
          const modal =
            this._modalSrv.openModal<ModalCreateConsultationComponent>(
              this._viewContainerRef,
              ModalCreateConsultationComponent
            ) as ComponentRef<ModalCreateConsultationComponent>;
          const sub = modal.instance.closeEmitter.subscribe(
            (consultationInfos?: ConsultationInfos) => {
              resolve(consultationInfos);
              modal.destroy();
              sub.unsubscribe();
            }
          );
        } catch (e) {
          reject(e);
        }
      }
    );
  }

  public async createConsultation(document: DocumentTableDisplay) {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      let createdConsultationId: string | undefined;
      const newDocument = this._documentSrv.convertDocumentToCreationDocument(
        document.meta
      );

      const consultationInfos = await this.createConsultationModal();
      if (!consultationInfos) return;
      const currentProfil = this._login.getCurrentProfil();
      createdConsultationId = await this._consultationSrv.create({
        date: consultationInfos.consultationDate,
        titre: consultationInfos.consultationTitle,
        idPatient: this.patientId,
        typeConsultation: consultationInfos.consultationType || undefined,
        auteur: {
          id: currentProfil?.id,
          autre: !currentProfil?.id ? AUTEUR_AUTRE : undefined,
        },
      });
      newDocument.consultationId = createdConsultationId;
      this._documentSrv.updateDocument(document.id, newDocument);
      // Mettre à jour le dataSource avec le nouveau titre
      const updatedData = this.dataSource.data.map((d) =>
        d.id === document.id
          ? { ...d, consultationTitre: consultationInfos.consultationTitle }
          : d
      );
      this.setDataSource(updatedData);
    } catch (error) {
      console.error('erreur lors de la créeation de la consultation', error);
      this._snakeBarSrv.openSnackBarError(
        'erreur lors de la création de la consultation.'
      );
    } finally {
      this._modalSrv.close(loading);
    }
  }
  public onChangePageFnc(page: number): void {
    this.onChangePage.emit(page);
  }

  public onSortFnc(sort: any): void {
    this.onSort.emit(sort);
  }

  public onPaginator(event: PageEvent): void {
    if (this.documentsTable?.perpage !== event.pageSize) {
      this.onChangePerPage.emit(event.pageSize);
    } else if (event.previousPageIndex !== event.pageIndex) {
      this.onChangePageFnc(event.pageIndex + 1);
    }
  }

  public async sendDocumentToPatient(document: DocumentTableDisplay) {
    const loader = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      const fileDocument = await this._documentSrv.downloadDocument(
        document.id
      );
      return new Promise(async (resolve, reject) => {
        if (this._viewContainerRef) {
          const quickSendMSS = this._modalSrv.openModal(
            this._viewContainerRef,
            QuickSendMSSFragment,
            [
              { name: 'idPatient', value: this.patientId },
              { name: 'title', value: document.title },
              {
                name: 'content',
                value: 'Envoi automatique du document ' + document.title,
              },
              {
                name: 'pieceJointe',
                value: {
                  fileName: document.title,
                  file: fileDocument?.payload,
                  size: document.formatFileSize,
                  contentType: document.meta?.contentType,
                },
              },
              { name: 'envoiPatient', value: true },
            ]
          );
          const sub = quickSendMSS.instance.closeEmitter.subscribe(
            async (response) => {
              sub.unsubscribe();
              quickSendMSS.destroy();
              resolve(response);
            }
          );
        }
      });
    } catch (error) {
      console.error("une erreur est survenu lors de l'envoi du mail", error);
      this._snakeBarSrv.openSnackBarError(
        "Une erreur est survenue lors de l'envoi du mail"
      );
    } finally {
      this._modalSrv.close(loader);
    }
  }

  public async openDocument(event: DocumentTableDisplay): Promise<void> {
    if (event.meta.isCrBio && event.meta.contentType == 'application/zip') {
      await this._displayCrBio(event.meta);
    } else {
      const displayDocumentInstance =
        (await this._displayDocumentSrv.displayDocument(
          this._viewContainerRef,
          this._displayDocumentSrv.documentToDisplayContentData(
            event.meta,
            this.patientId
          )
        )) as ComponentRef<DisplayDocumentComponent>;
      let currentDocumentId = event.id;
      displayDocumentInstance.instance.next.subscribe(
        async (next: AskNextDocument) => {
          const nextDocument = this._findNextDocument(currentDocumentId, next);
          currentDocumentId = nextDocument.id;
          await displayDocumentInstance.instance.showNextDocument(
            this._displayDocumentSrv.documentToDisplayContentData(
              nextDocument,
              this.patientId
            )
          );
        }
      );
    }
  }
  moreInfosBubble: { title: string; content: string }[] = [
    { title: 'Date création', content: 'createdAt' },
    { title: 'Date modification', content: 'upDatedAt' },
    { title: 'Type consultation', content: 'consultationType' },
    { title: 'CDA type', content: 'cdaType' },
    { title: 'CDA date', content: 'cdaDate' },
    { title: 'Auteur', content: 'author' }, //author pour historique imagerie et authorName pour historique courrier
    { title: 'Auteur', content: 'authorName' },
    { title: 'N° e-Prescription', content: 'eprescription' },
    { title: 'Type e-Prescription', content: 'typeEprescription' },
  ];
  public getTooltipContent(row: any): string {
    return this.moreInfosBubble
      .filter((item) => row[item.content] !== undefined)
      .map((item) => `${item.title}: ${row[item.content]}`)
      .join('\n');
  }

  private async _displayCrBio(document: DocumentMetadata): Promise<void> {
    if (document.isCrBio) {
      // Open loading modal
      const loadingModal = this._modalSrv.openLoading(this._viewContainerRef);
      // Get the infos of the CR
      let cr;
      try {
        cr = await this._documentSrv.getCrBioDonneesByDocumentId(document.id);
      } catch (e) {
        this._snakeBarSrv.openSnackBar(
          'Erreur lors de la récupération du CR de Bio'
        );
      } finally {
        // Close loading modal
        this._modalSrv.close(loadingModal);
      }
      if (!cr) {
        return;
      } else {
        const modal = this._modalSrv.openModal(
          this._viewContainerRef,
          ApercuCrbioComponent
        );
        modal.instance.infoReleve = { donneesBio: cr };
        modal.instance.documentId = document.id;
        modal.instance.closeEmitter.subscribe(async (res: boolean) => {
          this._modalSrv.close(modal);
        });
      }
    }
  }

  //bloquer
  public async addNewDocuments(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      if (
        this.showDisplay === false &&
        this.importDocumentsComponent.documentsTable &&
        this.importDocumentsComponent.documentsTable.objects &&
        this.importDocumentsComponent.documentsTable.objects.length > 0
      ) {
        const modal = this._modalSrv.openModalConfirmation(
          this._viewContainerRef,
          'Confirmation',
          'Les documents importés n’ont pas encore été ajoutés au dossier du patient, voulez-vous retourner à la liste des documents ?'
        );
        modal.instance.closeEmitter.subscribe(async (res: boolean) => {
          if (res) {
            this.showDisplay = true;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      } else {
        this.showDisplay = !this.showDisplay;
        resolve(true);
      }
    });
  }

  public importOverFnc(): void {
    this.importDocumentsComponent.documentsTable.objects = [];
    this.importOver.emit();
    this.showDisplay = true;
  }

  public async initTableDisplay(
    paginatedDocuments: Paginated<DocumentMetadata>
  ): Promise<Paginated<DocumentTableDisplay>> {
    const convertDocumentToListElem = (
      document: DocumentMetadata
    ): DocumentTableDisplay => {
      return {
        id: document.id,
        meta: document,
        formatFileSize: this.getFormatFileSize(document.weight),
        consultationDat: document.consultation
          ? `${moment(document.consultation.date).format('DD/MM/YYYY')}`
          : undefined,
        consultationTitre: document.consultation
          ? document.consultation.titre
          : undefined,
        consultationType: document.consultation
          ? document.consultation.type
          : undefined,
        createdAt: `${moment(document.createdAt).format(
          'DD/MM/YYYY'
        )} à ${moment(document.createdAt).format('HH:mm')}`,
        upDatedAt: `${moment(document.updatedAt).format(
          'DD/MM/YYYY'
        )} à ${moment(document.updatedAt).format('HH:mm')}`,
        cdaType: document?.cdaMetadata?.type?.displayName || 'Inconnu',
        cdaDate: document.cdaMetadata?.datetime
          ? moment(document.cdaMetadata.datetime).format('DD/MM/YYYY')
          : 'Inconnue',
        title: document.titre,
        author: `${document.auteurCreation.qualite} ${
          document.auteurCreation.nom
        } ${this._strUtilsSrv.uppercaseFirstCharString(
          document.auteurCreation.prenom
        )}`,
      };
    };

    const protocolsTmp: Array<DocumentTableDisplay> = [];
    for (const m of paginatedDocuments.objects) {
      protocolsTmp.push(convertDocumentToListElem(m));
    }

    const dmpDocument = await this._dmp.searchDMPDocumentByDocumentId(
      protocolsTmp.map((p) => p.id)
    );

    for (const p of protocolsTmp) {
      const dmpDoc = dmpDocument.find((d) => d.documentId === p.id);
      p.envoyeDMP = dmpDoc ? 'Oui' : 'Non';
      if (dmpDoc) {
        p.visibilityDMP = dmpDoc.documentDmp?.visibility
          ? (DmpVisibilityEnum[
              dmpDoc.documentDmp.visibility
            ] as unknown as DmpVisibilityEnum)
          : '';
      }
    }

    const rtd = {
      objects: protocolsTmp,
      page: paginatedDocuments.page,
      perpage: paginatedDocuments.perpage,
      total: paginatedDocuments.total,
    };

    // On extrait les document avec isCrBioOutOfRange à true pour leurs appliquer un style différent
    const outOfRangeDocs = rtd.objects.filter((o) => o.meta.isCrBioOutOfRange);
    for (const doc of outOfRangeDocs) {
      Object.defineProperty(doc, 'textColor', {
        configurable: true,
        value: 'var(--orange)',
      });
    }
    const criticalOutOfRangeDocs = rtd.objects.filter(
      (o) => o.meta.isCrBioCriticalOutOfRange
    );
    for (const doc of criticalOutOfRangeDocs) {
      Object.defineProperty(doc, 'textColor', {
        configurable: true,
        value: 'var(--danger)',
      });
    }

    return rtd;
  }

  getFormatFileSize(fileSize: number): string {
    const fileSizeString = fileSize.toString();
    let result: string;
    switch (true) {
      case fileSizeString.length > 0 && fileSizeString.length < 4:
        result = fileSizeString + ' octets';
        break;
      case fileSizeString.length >= 4 && fileSizeString.length < 7:
        result = Math.round((fileSize / 1000) * 10) / 10 + ' ko';
        break;
      case fileSizeString.length >= 7 && fileSizeString.length < 10:
        result = Math.round((fileSize / 1000000) * 10) / 10 + ' Mo';
        break;
      case fileSizeString.length >= 10 && fileSizeString.length < 13:
        result = Math.round((fileSize / 1000000000) * 10) / 10 + ' Go';
        break;
      case fileSizeString.length >= 13:
        result = Math.round((fileSize / 1000000000000) * 10) / 10 + ' To';
        break;
      default:
        result = 'NA';
        break;
    }
    result = result.replace('.', ',');
    return result;
  }

  private _findNextDocument(
    currentDocumentId: string,
    next: AskNextDocument
  ): DocumentMetadata {
    const nextDocument = (docId: string): DocumentMetadata => {
      const docIndex = this.documentsTable.objects.findIndex(
        (d) => d.id === docId
      );

      let nextIndex =
        next === AskNextDocument.Next ? docIndex + 1 : docIndex - 1;

      if (
        nextIndex === this.documentsTable.objects.length &&
        next === AskNextDocument.Next
      ) {
        nextIndex = 0;
      } else if (nextIndex < 0 && next === AskNextDocument.Previous) {
        nextIndex = this.documentsTable.objects.length - 1;
      }

      const nextDoc = this.documentsTable.objects[nextIndex];

      if (
        this._displayDocumentSrv.canDisplayDocument(nextDoc.meta.contentType)
      ) {
        return nextDoc.meta;
      } else {
        return nextDocument(nextDoc.id);
      }
    };

    return nextDocument(currentDocumentId);
  }

  /**
   * Vérifie si un document est sélectionné pour le comparateur d'images
   */
  public isDocumentSelected(docId: string): boolean {
    return this.selectedImagesIds.includes(docId);
  }

  public isImageDocument(doc: DocumentTableDisplay): boolean {
    const imageTypes = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg'];
    return imageTypes.includes(doc.meta?.contentType?.toLowerCase());
  }

  public toggleSelection(doc: DocumentTableDisplay): void {
    if (this.comparisonMode) {
      this.onImageSelectionToggle.emit(doc.meta);
    }
  }

  /**
   * Permet de basculer le statut privé d'un document
   * Seul le médecin responsable du dossier ou le créateur du doc peut effectuer cette action
   */
  public async togglePrivateStatus(document: DocumentTableDisplay): Promise<void> {
    // Vérifier que l'utilisateur est le médecin responsable ou l'auteur du doc
    const canModify = await this._accessControl.canModifyPrivateStatus(this.patientId, document.meta?.auteurCreation?.id);
    
    if (!canModify) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Action non autorisée',
        'Seul le médecin responsable du dossier et le créateur du document peuvent modifier le statut de confidentialité des documents.'
      );
      return;
    }
    
    const newStatus = !document.meta.isPrivate;
    const action = newStatus ? 'privé' : 'public';
    
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Confirmation',
      `Voulez-vous rendre ce document ${action} ?${newStatus ? '\n\nLe document ne sera plus visible par les autres professionnels de la structure.' : ''}`
    );
    
    modal.instance.closeEmitter.subscribe(async (confirmed: boolean) => {
      if (confirmed) {
        const loading = this._modalSrv.openLoading(this._viewContainerRef);
        try {
          const updatedDoc = this._documentSrv.convertDocumentToCreationDocument(document.meta);
          updatedDoc.isPrivate = newStatus;
          
          await this._documentSrv.updateDocument(document.id, updatedDoc);
          
          // Mettre à jour localement
          document.meta.isPrivate = newStatus;
          
          this._snakeBarSrv.openSnackBar(
            `Document marqué comme ${action} avec succès`
          );
        } catch (error) {
          this._modalSrv.openAlert(
            this._viewContainerRef,
            'Erreur',
            'Une erreur est survenue lors de la modification du statut de confidentialité.'
          );
        } finally {
          this._modalSrv.close(loading);
        }
      }
    });
  }

}
